import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { analytics } from "@silvertours/front-entities";
import { OffersList } from "../OffersList";
import { OfferBox } from "../OfferBox";
import { OfferDetails } from "./OfferDetails";
var OffersModule = function(param) {
    var content = param.content, onClick = param.onClick, translations = param.translations;
    return /*#__PURE__*/ _jsx(OffersList, {
        badge: translations.badgeText,
        disclaimer: translations.disclaimer,
        disclaimerOverlayCTA: translations.disclaimerOverlayCTA,
        title: translations.headline,
        titleColor: "white",
        waveColor: "orange",
        offerDetails: /*#__PURE__*/ _jsx(OfferDetails, {
            content: content,
            translations: translations
        }),
        offerDetailsTitle: translations.offerDetailsTitle,
        children: Object.entries(content).map(function(param) {
            var _param = _sliced_to_array(param, 2), category = _param[0], offersData = _param[1];
            var handleClick = onClick ? function() {
                if (onClick) {
                    onClick(offersData.searchQuery);
                    analytics.gtm.trackSearchButtonOfferBoxClicked();
                }
            } : undefined;
            return /*#__PURE__*/ _jsx(OfferBox, {
                category: translations.carTypes[category],
                image: offersData.offers[0].image,
                onClick: handleClick,
                offers: offersData.offers.map(function(offer) {
                    return {
                        currency: "EUR",
                        price: offer.price,
                        supplier: offer.supplier
                    };
                }),
                translations: {
                    pricePrefix: translations.pricePrefix,
                    priceSuffix: translations.priceSuffix,
                    searchButtonText: translations.searchButtonText
                }
            }, category);
        })
    });
};
export { OffersModule };
